document.addEventListener('DOMContentLoaded', function () {

  function fixThumbnailScroll() {
    document.querySelectorAll('.thumbnail-list__item button.thumbnail').forEach(function (btn) {
      if (btn.dataset.scrollFixed) return;
      btn.dataset.scrollFixed = 'true';

      btn.addEventListener('click', function () {
        const scrollY = window.scrollY;

        // Lock scroll across multiple frames — theme JS may fire late
        let frames = 0;
        function lockScroll() {
          window.scrollTo({ top: scrollY, behavior: 'instant' });
          frames++;
          if (frames < 10) requestAnimationFrame(lockScroll);
        }
        requestAnimationFrame(lockScroll);
      });
    });
  }

  fixThumbnailScroll();

  const observer = new MutationObserver(function () {
    fixThumbnailScroll();
  });

  const sliderEl = document.querySelector('.thumbnail-list');
  if (sliderEl) {
    observer.observe(sliderEl, { childList: true, subtree: true });
  }

});


// ─── VERY IMPORTANT DONT TOUCH Haute Care Form — File Upload to Server ───────────────────────────────

(function () {
  const form        = document.getElementById('HauteCareForm');
  const fileInput   = document.getElementById('HauteCareForm-invoice');
  const urlField    = document.getElementById('HauteCareForm-invoice-url');
  const submitBtn   = document.querySelector('#HauteCareForm .hc-submit[type="submit"]');
  const uploadTitle = document.querySelector('[data-hc-upload-title]');

  const uploadEndpoint = 'https://hautekitchen-in.stackstaging.com/haute-upload/upload.php';

  if (!form || !fileInput || !urlField || !submitBtn) return;

  const originalButtonHTML = submitBtn.innerHTML;

  const status = document.createElement('p');
  status.className = 'hc-upload-status';
  status.style.cssText = 'font-size:12px; margin-top:8px; color:#8a7f75;';
  fileInput.closest('.hc-upload').after(status);

  function setStatus(msg, color) {
    status.textContent = msg;
    status.style.color = color || 'inherit';
  }

  fileInput.addEventListener('change', async function () {
    const file = this.files[0];
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxSize = 10 * 1024 * 1024;

    if (!allowedTypes.includes(file.type)) {
      setStatus('Invalid file type. Only JPG, PNG and PDF allowed.', 'red');
      urlField.value = '';
      fileInput.value = '';
      return;
    }

    if (file.size > maxSize) {
      setStatus('File too large. Maximum 10MB allowed.', 'red');
      urlField.value = '';
      fileInput.value = '';
      return;
    }

    if (uploadTitle) {
      uploadTitle.textContent = file.name;
    }

    submitBtn.disabled = true;
    submitBtn.innerHTML = 'Uploading invoice...';
    setStatus('Uploading your invoice, please wait...', '#8a7f75');

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await fetch(uploadEndpoint, {
        method: 'POST',
        body: formData
      });

      const data = await res.json();

      if (data.success && data.url) {
        urlField.value = data.url;
        setStatus('Invoice attached. You can now submit the form.', '#8a7f75');
      } else {
        urlField.value = '';
        fileInput.value = '';
        setStatus('Upload failed: ' + (data.error || 'Please try again.'), 'red');
      }
    } catch (err) {
      urlField.value = '';
      fileInput.value = '';
      setStatus('Upload failed. Please check your connection and try again.', 'red');
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalButtonHTML;
    }
  });

  form.addEventListener('submit', function (e) {
    if (!urlField.value) {
      e.preventDefault();
      setStatus('Please upload your invoice before submitting.', 'red');
      fileInput.focus();
    }
  });
})();